/**
 * Normaliza un texto.
 * @param {string} text
 * @return {string}
 */
function normalize(text = "") {
  return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
}

/**
 * Calcula una puntuación de coincidencia.
 * @param {string[]} searchWords
 * @param {string[]} patientWords
 * @return {number}
 */
function calculateScore(
    searchWords,
    patientWords,
) {
  let score = 0;

  for (const word of searchWords) {
    if (patientWords.includes(word)) {
      score++;
    }
  }

  return score;
}

/**
 * Busca el paciente más parecido.
 * @param {string} googleTitle
 * @param {Array<Object>} patients
 * @return {Object|null}
 */
function findBestPatientMatch(
    googleTitle,
    patients,
) {
  if (!googleTitle) {
    return null;
  }

  const searchWords =
      normalize(googleTitle).split(" ");

  let bestPatient = null;
  let bestScore = 0;

  for (const patient of patients) {
    const fullName = `${patient.nombre || ""} ${patient.apellidos || ""}`;

    const patientWords =
        normalize(fullName).split(" ");

    const score =
        calculateScore(
            searchWords,
            patientWords,
        );

    if (score > bestScore) {
      bestScore = score;
      bestPatient = patient;
    }
  }

  if (!bestPatient) {
    return null;
  }

  return {
    patient: bestPatient,
    score: bestScore,
  };
}

module.exports = {
  findBestPatientMatch,
};
